// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { View } from "./View";
import { ViewFromJSON, ViewFromJSONTyped, ViewToJSON, ViewToJSONTyped } from "./View";

/**
 *
 * @export
 * @interface Presentation
 */
export interface Presentation {
  /**
   *
   */
  view?: View;
}

/**
 * Check if a given object implements the Presentation interface.
 */
export function instanceOfPresentation(value: object): value is Presentation {
  return true;
}

export function PresentationFromJSON(json: any): Presentation {
  return PresentationFromJSONTyped(json, false);
}

export function PresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Presentation {
  if (json == null) {
    return json;
  }
  return {
    view: json["view"] == null ? undefined : ViewFromJSON(json["view"]),
  };
}

export function PresentationToJSON(json: any): Presentation {
  return PresentationToJSONTyped(json, false);
}

export function PresentationToJSONTyped(
  value?: Presentation | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    view: ViewToJSON(value["view"]),
  };
}
